var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-empty',{attrs:{"description":_vm.$t('Nema poruka'),"image":_setup.simpleImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }